import { render, staticRenderFns } from "./PermissionsGroupHead.vue?vue&type=template&id=17fe0ddb"
import script from "./PermissionsGroupHead.vue?vue&type=script&lang=js"
export * from "./PermissionsGroupHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports